module.exports = "/static/assets/aaf46bc6028bf524feb99328641419dd.png";